import { Button } from "@material-ui/core";
import GetAppSharpIcon from "@material-ui/icons/GetAppSharp";
import Config from "Config";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { isEmpty, isNotEmpty } from "../../Utils";
import { addAttachment } from "../../redux/action";
import { getAttachment } from "../../redux/selector";

export function DownloadButton({ fileName, fileId, buttonClass }) {
    const dispatch = useDispatch();
    const [downloadUrl, setDownloadUrl] = useState("");
    const fileContent = useSelector(getAttachment(fileId));
    const downloadLink = useRef(null);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        if (isEmpty(fileContent)) {
            setDownloadUrl("");
        } else {
            setDownloadUrl(fileContent ? URL.createObjectURL(fileContent) : "");
        }
        return () => {
            URL.revokeObjectURL(downloadUrl);
        };
    }, [fileContent]);

    const onDownload = () => {
        if (isNotEmpty(fileContent)) {
            downloadLink.current.click();
        } else {
            const option = {
                url: `${Config.CONTENT_PATH}/attachment/${fileId}`,
            };
            dispatch(send("GET_ATTACHMENT", option))
                .then((res) => res.blob())
                .then((fileContent) => {
                    dispatch(addAttachment({ [fileId]: fileContent }));
                    setTimeout(() => {
                        downloadLink.current.click();
                    }, 500);
                });
        }
    };

    return (
        <>
            <a
                ref={downloadLink}
                href={downloadUrl}
                download={fileName}
                aria-label={fileName}
            >
                <i className="hidden">{fileName}</i>
            </a>

            <Button
                variant="contained"
                color="primary"
                className={
                    buttonClass
                        ? [buttonClass, "mr20 removeBtn"]
                        : "mr20 removeBtn"
                }
                onClick={onDownload}
                startIcon={<GetAppSharpIcon />}
            >
                {t(`common.download`)}
            </Button>
        </>
    );
}
